import { render, staticRenderFns } from "./TrainingProgramsPage.vue?vue&type=template&id=108720a3&"
import script from "./TrainingProgramsPage.vue?vue&type=script&lang=js&"
export * from "./TrainingProgramsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports